<template>
  <div
    class="page-loader"
    v-if="!isLoaded"
  >
    <v-row class="center wrapper">
      <div
        cols="12"
        class="box"
      >
        <div align="center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 50 80"
          >
            <g id="drawing">
              <path
                d="M49.07,9.38a1.53,1.53,0,0,0-1.67-.73A18.23,18.23,0,0,0,44,9.71a91.25,91.25,0,0,0-8.91,3.69c-1.89.89-3.73,1.94-5.66,2.75C31.28,13.77,33.12,11.37,35,9c1-1.24,2-2.44,3-3.7a8.08,8.08,0,0,0,1.57-2.8A1.59,1.59,0,0,0,39.21.94,1.75,1.75,0,0,0,37.72.65a30.19,30.19,0,0,0-2.93.79C30.51,2.66,26.64,5,22.44,6.39c.08-1,.19-2,.19-3A5.64,5.64,0,0,0,22.57,2,1.34,1.34,0,0,0,20.81.93c-.68.26-1,1-1.25,1.63-.74,1.5-1.36,3.07-2,4.61-1,2.43-2,4.86-2.86,7.35s-1.43,4.84-2.08,7.28c-.31,1.19-.6,2.39-.92,3.58a15.86,15.86,0,0,0-.51,1.88A3.92,3.92,0,0,1,11,26c-.1-1-.14-1.9-.19-2.86-.09-2.19-.16-4.38-.25-6.57,0-.93.06-1.87,0-2.79s0-2-.15-2.93a1.57,1.57,0,0,0-.78-1.36,1.33,1.33,0,0,0-1.8.84,13.31,13.31,0,0,0-.44,1.89c-.23,1.17-.44,2.35-.73,3.51-.73,3-1.62,5.84-2.42,8.77-.68,2.53-1.28,5.08-2,7.61-.36,1.34-.88,2.62-1.21,4a2.49,2.49,0,0,0-.05,1.74c.48.77,1.31,0,1.52-.51a53.87,53.87,0,0,0,1.88-5.4c.47-1.66.93-3.33,1.36-5s.87-3.14,1.37-4.68a21.83,21.83,0,0,0,1-3.32,4.59,4.59,0,0,1,.07.91c0,.67,0,1.34.06,2A51.06,51.06,0,0,0,8.76,28c.18,1.06.36,2.7,1.39,3.3a1.59,1.59,0,0,0,2.1-.57,11.77,11.77,0,0,0,1.45-3.83C14.78,23,15.59,19,16.89,15.17c.58-1.74,1.29-3.43,2-5.14a23.36,23.36,0,0,0,.91-2.27,9.92,9.92,0,0,1-.25,2.47c-.22,2-.46,4-.65,6-.22,2.34-.31,4.69-.47,7C18.16,26.84,18,30.41,18,34c0,2.34-.06,4.68-.06,7,0,.54,0,1.09,0,1.63a1.8,1.8,0,0,1-.05,1.1,13.94,13.94,0,0,1-1.38,1.69c-.82,1-1.63,2-2.45,3-2.64,3.23-5.3,6.45-7.93,9.69-.92,1.14-1.87,2.25-2.8,3.38-.4.48-.93,1.08-.72,1.76s1,0,1.29-.19a13.91,13.91,0,0,0,1.51-1.56c.46-.49,1-.95,1.41-1.44,2.68-2.8,5.16-5.79,7.69-8.71.83-1,1.67-1.89,2.48-2.86a7.08,7.08,0,0,0,1.08-1.37,12.85,12.85,0,0,1,.14,2.41c.19,2,.26,4.08.46,6.11.53,5.48,1.25,10.93,2,16.39.27,2,.52,3.94.7,5.91.05.53.16,1.71,1,1.45s.52-1.45.52-2c0-2.13-.31-4.24-.45-6.37-.17-2.38-.48-4.77-.71-7.15-.37-3.92-.53-7.85-.8-11.77-.11-1.6-.08-3.21-.19-4.81,0-.7-.06-1.38-.06-2.08a4.48,4.48,0,0,1,0-1,2,2,0,0,1,.5-.72l1.07-1.3c1.37-1.69,2.8-3.33,4.18-5,4.13-5,8.47-9.76,12.81-14.56,1.12-1.23,2.19-2.5,3.33-3.71a73,73,0,0,0,5.49-6.43C48.66,11.65,49.55,10.42,49.07,9.38ZM45,12.89c-1.15,1.34-2.29,2.67-3.47,4-3.2,3.56-6.47,7-9.68,10.6-2.64,2.91-5.18,5.91-7.73,8.9l-2.29,2.73a11.06,11.06,0,0,1-1.18,1.37c0-3.66.11-7.33.2-11,.1-4.38.22-8.76.64-13.13.19-2,.31-3.95.57-5.92.05-.45.1-.91.14-1.36a1.09,1.09,0,0,1,.13-.62c.23-.27.85-.36,1.18-.47.94-.31,1.88-.65,2.8-1,3.56-1.42,7-3.29,10.79-4.07A34.26,34.26,0,0,1,33.9,7c-1.9,2.44-3.8,4.88-5.66,7.35a19.33,19.33,0,0,0-1.86,2.73,1.27,1.27,0,0,0,0,1.55c.5.54,1.14.39,1.74.15a37.17,37.17,0,0,0,3.51-1.62C35,15.54,38.35,14,41.81,12.63c1-.39,2-.8,3-1.17a9,9,0,0,1,1.82-.58,16.88,16.88,0,0,1-1.66,2Z"
                transform="translate(-0.29 -0.1)"
              />
            </g>
            Your browser does not support inline SVG
          </svg>
        </div>
        <h1>This is art?</h1>
        <h2>Mari Brønseth</h2>
      </div>
    </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoaded: false
    }
  },
  mounted() {
    setTimeout(() => {
      this.isLoaded = true;
    }, 3500);
  }
}
</script>

<style scoped>
.page-loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  background-color: var(--v-background-base);
}

.box {
  padding: 4rem 3rem;
  border: 1px solid var(--v-tertiary-base);
  max-width: 600px;
  opacity: 0;
  animation: fadeIn 0.3s ease-in-out forwards;
}

@keyframes fadeIn {
  to {
    opacity: 1;
  }
}

#drawing {
  stroke: var(--v-tertiary-base);
  opacity: 0;
  fill: none;
  stroke-dasharray: 2000;
  stroke-dashoffset: 0;
  stroke-miterlimit: 10;
  stroke-width: 1px;

  animation: draw ease-in-out 3s forwards;
  animation-delay: 0.3s;
}

@keyframes draw {
  0% {
    opacity: 0;
    stroke-dashoffset: 2000;
  }
  1% {
    opacity: 1;
    stroke-dashoffset: 2000;
  }
  100% {
    opacity: 1;
    stroke-dashoffset: 0;
  }
}

svg {
  height: 150px;
}

h1 {
  color: var(--v-tertiary-base);
  font-size: 6rem;
  font-weight: 600;
  letter-spacing: 5px;
  line-height: 1.5;
  opacity: 0;
  transform: translateY(1rem);
  animation: fadeInUp 1s ease 1.5s forwards;
}

@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
h2 {
  font-size: 2rem;
  margin: 0;
  line-height: 1;
  color: var(--v-tertiary-base);
  opacity: 0.75;
  letter-spacing: 0px;
}

@media only screen and (max-width: 575px) {
  h1 {
    font-size: 3rem;
    letter-spacing: 2px;
  }
  h2 {
    font-size: 1.5rem;
  }
  .box {
    padding: 3rem 2rem;
    max-width: 350px;
  }
}
</style>